/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { useField } from 'formik';
import apiService from '@services/apiService';

const FormikSelect = ({
  disabled,
  name,
  value,
  onBlur,
  onChange,
  multiselect,
  comboBoxLookupName,
}) => {
  const [field, , helpers] = useField(name);
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState([]);

  const comboVal = useMemo(() => options.find(item => item.Code === value), [value, options]);

  useEffect(() => {
    if (comboBoxLookupName) {
      const getOptions = async () => {
        try {
          const [definitions] = await apiService.Definitions.PostToLookupTable({ lookupNames: [comboBoxLookupName] });
          if (value) {
            const currValue = definitions.data.find(item => item.Code === value);
            if (currValue.Active === false) {
              currValue.Active = true;
              currValue.Description += ' (disabled)';
            }
          }
          setOptions(definitions.data.filter(item => item.Active === true));
          setIsLoading(false);
        } catch (er) {
          console.error('Error: FormikSelect comboBoxLookup', er);
        }
      };

      getOptions();
    }
  }, [comboBoxLookupName]);

  const handleChange = val => {
    const selectVal = multiselect && val?.length
      ? val.map(({ Code }) => Code)
      : val?.Code;
    if (field?.value === selectVal) return;
    if (onChange) {
      onChange(selectVal);
    } else {
      helpers.setValue(selectVal);
    }
  };

  return (
    <Select
      inputId={name}
      name={name}
      className="react-select-container"
      classNamePrefix="react-select"
      value={comboVal}
      closeMenuOnSelect={!multiselect}
      isDisabled={disabled || isLoading}
      isMulti={multiselect}
      isClearable
      isLoading={isLoading}
      onBlur={onBlur}
      onChange={handleChange}
      options={options}
      autoComplete="off"
      placeholder={`Choose one ${multiselect ? 'or more' : ''}`}
      getOptionLabel={({ Description }) => Description}
      getOptionValue={({ Code }) => Code}
      menuShouldScrollIntoView
      menuPortalTarget={document.querySelector('body')}
      styles={{
        option: (styles, { data }) => ({
          ...styles,
          fontStyle: data?.Description?.endsWith('(disabled)') ? 'italic !important' : styles.fontStyle,
          filter: data?.Description?.endsWith('(disabled)') ? 'grayscale(90%) !important' : styles.filter,
          opacity: data?.Description?.endsWith('(disabled)') ? '0.8 !important' : styles.opacity,
        }),
        singleValue: (styles, { data }) => ({
          ...styles,
          fontStyle: data?.Description?.endsWith('(disabled)') ? 'italic !important' : styles.fontStyle,
          filter: data?.Description?.endsWith('(disabled)') ? 'grayscale(90%) !important' : styles.filter,
          opacity: data?.Description?.endsWith('(disabled)') ? '0.8 !important' : styles.opacity,
        }),
        multiValue: (styles, { data }) => ({
          ...styles,
          fontStyle: data?.Description?.endsWith('(disabled)') ? 'italic !important' : styles.fontStyle,
          filter: data?.Description?.endsWith('(disabled)') ? 'grayscale(90%) !important' : styles.filter,
          opacity: data?.Description?.endsWith('(disabled)') ? '0.8 !important' : styles.opacity,
        }),
        menuPortal: styles => ({ ...styles, zIndex: 9999 }),
      }}
    />
  );
};

FormikSelect.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  multiselect: PropTypes.bool,
  comboBoxLookupName: PropTypes.string,
};

export default FormikSelect;
